import type { StateMapping, WidgetTone } from "../types";
import { MAX_STATE_MAPPINGS, normalizeStateMappings, STATE_TONES } from "../stateMappings";

export interface StateMappingDraft { value: string; label: string; tone: WidgetTone }

export function parseStateMappingDraft(rows: StateMappingDraft[]): StateMapping[] | undefined {
  if (rows.some((row) => !row.value.trim())) return undefined;
  return normalizeStateMappings(rows.map((row) => ({ ...row, value: Number(row.value) })));
}

const TONE_LABELS: Record<WidgetTone, string> = {
  neutral: "Neutro", info: "Informação", ok: "Normal", warn: "Atenção", danger: "Alarme",
};

export function StateMappingFields({ rows, onChange, error }: {
  rows: StateMappingDraft[];
  onChange: (rows: StateMappingDraft[]) => void;
  error?: string;
}) {
  const update = (index: number, patch: Partial<StateMappingDraft>) =>
    onChange(rows.map((row, i) => i === index ? { ...row, ...patch } : row));
  return <fieldset className="modal__fieldset">
    <legend>Estados por código</legend>
    <p className="hint">Defina o significado de cada código recebido. Códigos não mapeados ficam visíveis, sem classificação. Falha de comunicação nunca vira um estado normal.</p>
    {rows.map((row, i) => <div key={i} className="form-grid form-grid--3">
      <label className="field">
        <span className="field__label">Código {i + 1}</span>
        <input className="input field__control" value={row.value} inputMode="decimal" aria-invalid={!!error} onChange={(e) => update(i, { value: e.target.value })} />
      </label>
      <label className="field">
        <span className="field__label">Texto {i + 1}</span>
        <input className="input field__control" value={row.label} maxLength={80} onChange={(e) => update(i, { label: e.target.value })} />
      </label>
      <div>
        <label className="field">
          <span className="field__label">Cor {i + 1}</span>
          <select className="input field__control" value={row.tone} onChange={(e) => update(i, { tone: e.target.value as WidgetTone })}>
            {STATE_TONES.map((tone) => <option key={tone} value={tone}>{TONE_LABELS[tone]}</option>)}
          </select>
        </label>
        <button type="button" className="btn ghost" onClick={() => onChange(rows.filter((_, index) => index !== i))}>Remover código {i + 1}</button>
      </div>
    </div>)}
    {error ? <p className="field__error" role="alert">{error}</p> : null}
    <button type="button" className="btn ghost" disabled={rows.length >= MAX_STATE_MAPPINGS} onClick={() => onChange([...rows, { value: "", label: "", tone: "neutral" }])}>Adicionar código</button>
  </fieldset>;
}
